module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//default_bg.jpg?v=8b034ded";